(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    

/* ============================================================
   PETCHAT PRODUCT PAGE
   Gallery + quantity enhancements.
   Existing barkly.js variant/cart hooks remain intact.
============================================================ */

(function () {

  /* ----------------------------------------------------------
     GALLERY
  ---------------------------------------------------------- */

  var mainImage =
    document.querySelector('[data-main-image]');

  var mirrorImage =
    document.querySelector('[data-main-image-mirror]');

  var thumbs =
    document.querySelectorAll('[data-thumb]');


  thumbs.forEach(function (button) {

    button.addEventListener('click', function () {

      if (!mainImage) return;


      thumbs.forEach(function (thumb) {
        thumb.classList.remove('is-active');
      });


      button.classList.add('is-active');


      mainImage.style.opacity = '0';


      setTimeout(function () {

        mainImage.src =
          button.dataset.src;

        mainImage.srcset = '';

        mainImage.style.opacity =
          '1';


        if (mirrorImage) {
          mirrorImage.src =
            button.dataset.src;
        }

      }, 130);

    });

  });
/* ----------------------------------------------------------
   QUANTITY
---------------------------------------------------------- */

var quantityValue = document.querySelector('[data-qty-value]');
var quantityInput = document.querySelector('[data-quantity-input]');
var quantityButtons = document.querySelectorAll('[data-qty-step]');

quantityButtons.forEach(function (button) {
  if (button.dataset.quantityBound === 'true') return;

  button.dataset.quantityBound = 'true';

  button.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();

    if (!quantityValue) return;

    var current = parseInt(quantityValue.textContent, 10) || 1;
    var step = parseInt(button.dataset.qtyStep, 10) || 0;
    var next = Math.max(1, current + step);

    quantityValue.textContent = next;

    if (quantityInput) {
      quantityInput.value = next;
    }
  });
});

  /* ----------------------------------------------------------
     ACTIVE SWATCH VISUALS
     barkly.js can continue handling the actual variant update.
  ---------------------------------------------------------- */

  var swatches =
    document.querySelectorAll('[data-variant-swatch]');


  swatches.forEach(function (swatch) {

    swatch.addEventListener('click', function () {

      swatches.forEach(function (item) {

        item.classList.remove('is-active');

        item.setAttribute(
          'aria-pressed',
          'false'
        );

      });


      swatch.classList.add('is-active');

      swatch.setAttribute(
        'aria-pressed',
        'true'
      );


      var colorName =
        document.querySelector('[data-color-name]');


      if (
        colorName &&
        swatch.dataset.variantTitle
      ) {

        colorName.textContent =
          swatch.dataset.variantTitle;

      }

    });

  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-embed"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.videosec__facade').forEach(function (b) { b.addEventListener('click', function () { var id = b.getAttribute('data-yt'); var f = document.createElement('iframe'); f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0'; f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'; f.allowFullscreen = true; f.title = 'Petchat AI video'; b.replaceWith(f); }); });

  } catch(e) { console.error(e); }
})();
})();
